/* eslint-disable unicode-bom */
import './rules.scss';
import schema_prihlaseni from '../../resources/images/prihlaseni_2026.jpg';
import { EPage, Section, Heading } from '@sifrovacihra/shared-ui';
import { changePage } from '../../utils';
import { useNavigate } from 'react-router-dom';


export const Rules = () => {

    const navigate = useNavigate()

    return (
        <div className='rules'>
            <Heading
                headline="Pravidla"
                weight={1}
            />


            <Section>
                <Heading
                    headline="ŠifT 2026"
                    weight={2}
                />
                <ul>
                    <li>Hra se koná v sobotu 23. května 2026 v Táboře a blízkém okolí.</li>
                    <li>Hra se koná za každého počasí.</li>
                </ul>
            </Section>


            <Section>
                <Heading
                    headline="Přihlášení"
                    weight={2}
                />
                <ul>
                    <li>Hry se mohou zúčastnit pouze týmy, které se dopředu přihlásí zde na webu nejpozději do půlnoci 19. května.</li>
                    <li>V případě naplnění kapacity hry bude přihlašování dalších týmů zastaveno.</li>
                    <li><strong>Startovné ve výši 300 Kč/tým se letos platí online převodem</strong>, instrukce k platebnímu příkazu uvidíte po registraci na stránce týmu. Startovné je nutné uhradit do 20. května (a ideálně do 14 dnů od registrace). Při odhlášení týmu před ukončením registrace bude vráceno startovné snížené o poplatek 60 Kč. Jestliže se tým odhlásí po ukončení registrace, zaplacené startovné se nevrací.</li>
                    <li>Registrace týmů proběhne v sobotu <b>23. 5. 2026 od 8:30 do 8:45 na <a href="https://mapy.com/s/faretogulu" target="_blank" rel="noreferrer">dopravním hřišti Jordán </a></b>(kousek od autobusového i vlakového nádraží).</li>
                    <li>Za člena týmu považujeme každého, kdo se účastní luštění šifer, bez ohledu na věk. </li>
                </ul>
            </Section>

            <Section>
                <Heading
                    headline="Kategorie"
                    weight={2}
                />
                <ul>
                    <li>Letos si při registraci můžete vybrat kategorii Začátečníci nebo Pokročilí:
                        <ul>
                            <li><b>Začátečníci</b> jsou určeni především pro ty, kdo jdou na šifrovačku poprvé nebo si tolik nevěří. Obtížnostně budou laděni k <span onClick={() => changePage(EPage.HISTORY, navigate)} className='href'>1. ročníku ŠifTu</span>.</li>
                            <li><b>Pokročilí</b> jsou pro ty, kdo už mají nějakou šifrovačku za sebou nebo chtějí pořádnou výzvu. Obtížnostně budou navazovat na <span onClick={() => changePage(EPage.HISTORY, navigate)} className='href'>3. ročník hry</span>.</li>
                        </ul>
                    </li>
                    <li>Start i cíl je pro obě kategorie stejný, na stanovištích ale budou většinou dostávat různé šifry. Trasa pro Pokročilé bude obsahovat o cca 2 stanoviště víc.</li>
                </ul>
            </Section>


            <Section>
                <Heading
                    headline="Průběh hry"
                    weight={2}
                />
                <ul>
                    <li>Cílem šifrovací hry ŠifT je postupně vyluštit všechny šifry umístěné na trase po Táboře a získat cílové heslo. To vše v co nejkratším možném čase.</li>
                    <li><b>Hromadný start</b> proběhne v sobotu 23. 5. 2026 v <b>9:00 na dopravním hřišti Jordán</b>.</li>
                    <li>Až po odstartování hry můžete otevřít obálku s 1. šifrou. Tu získáte při registraci před hromadným startem.</li>
                    <li>Vyluštění první šifry vás pošle na další stanoviště. Tam vyhledáte a vyzvednete z plastových desek další šifru - papír s logem ŠifT a jménem dané šifry (každá šifra má své jméno). <b>Berte si vždy pouze dva papíry se zadáním šifry a zanechte desky na stejném místě pro další spoluhráče!</b></li>
                    <li>Všechny obdržené materiály i vyluštěné šifry si nechávejte a nezahazujte, nikdy nevíte, jestli se ještě někdy nebudou hodit.</li>
                    <li>V případě, že si nebudete vědět rady nebo vás bude tlačit čas, můžete použít  nápovědu nebo řešení šifry. To vám pomůže k nalezení dalšího stanoviště. Nápovědy bude možné čerpat přes websystém.</li>
                    <li>Hru ukončíte příchodem do cíle a odevzdáním cílového hesla. Polohu cíle se dozvíte z poslední šifry.</li>
                    <li>Trasa je vytvořena tak, abyste ji stihli cca za 4 hodiny. O pořadí rozhoduje počet vyluštěných šifer (čím více, tím lépe) a celkový čas (čím kratší, tím lepší). Luštit ale můžete až do 17:00, pokud vás šifry budou bavit :)</li>
                    <li>Vyhlášení vítězů proběhne ve <b>14:00 v cíli</b> hrát ale můžete až do 17:00. Výsledky budou také zveřejněny na webu a Facebooku knihovny.</li>
                </ul>
            </Section>
            
            <Section nopadding={true}>
                <img src={schema_prihlaseni} alt="Schéma přihlašování" className='banner' />
            </Section>
            
            <Section>
                <Heading
                    headline="Websystém a nápovědy"
                    weight={2}
                />
                <ul>
                    <li>I letos na hru bude dohlížet websystém, přístup do něj dostanete po registraci. <b>Pro přihlášení do websystému budete potřebovat heslo</b>, které jste si zvolili při přihlašování týmu do hry.</li>
                    <li>Každá šifra má svůj název napsaný pod logem hry v levém horním rohu papíru. Jakmile šifru objevíte, zadáte do websystému název této šifry. Díky tomu budete moci čerpat nápovědy nebo řešení. Websystém bude zároveň sloužit k určení výsledného pořadí ve hře.</li>
                    <li>Nápovědu nebo řešení šifry můžete použít v případě, že si nebudete vědět rady nebo vás bude tlačit čas. To vám pomůže k nalezení dalšího stanoviště.</li>
                    <li>Letos budou na každém stanovišti k dispozici 2 nápovědy a Řešení, které je nutné brát v následujícím pořadí:
                        <ul>
                            <li><b>Drobná nápověda</b> - napoví, co s šifrou dělat, za použití se vám v cíli k času přičte 15 minut,</li>
                            <li><b>Postup</b> - vysvětlí všechny kroky šifry, ale doluštit budete muset sami, za použití se vám v cíli k času přičte dalších 15 minut,</li>
                            <li><b>Řešení</b> - prozradí lokaci další šifry, za použití se vám v cílí k času přičte dalších 30 minut.</li>
                        </ul>
                    </li>
                    <li>Pro kategorii <b>Pokročilí platí následující změny</b>:
                        <ul>
                            <li>trestné časy za použití nápověd jsou dvojnásobné,</li>
                            <li>jako vyřešená šifra se pro stanovení pořadí počítá pouze ta, kde tým nevzal Řešení,</li>
                            <li>pokud tým na šifře použil Řešení, na dané šifře se mu nepřičítá žádný trestný čas (ani za drobnou nápovědu či Postup na dané šifře).</li>
                        </ul>
                    </li>
                    

                </ul>
            </Section>

            <Section>
                <Heading
                    headline="Obecné pokyny"
                    weight={2}
                />
                <ul>
                    <li><b>Co nezapomenout s sebou!</b> Mobilní telefon s daty, tužku, papír (nejlépe čtverečkovaný), nůžky, izolepu/lepidlo, kružítko a pravítko. Zajistit si pitný režim a být připraven i na nepřízeň počasí.</li>
                    <li><b>Hrajte férově!</b> Není povoleno sledovat jiné týmy, odposlouchávat nebo opisovat jejich řešení šifer, hledat další stanoviště odhadem a jinak nečestně si dopomáhat k rychlejšímu postupu hrou.</li>
                    <li>Pro přesun mezi stanovišti je povolena chůze/běh, jezdit autem, na kole, koloběžce ... je zakázáno</li>
                    <li>Pokud byste se cestou ztratili, a to jak v šifrách, tak i na trase, je vždy možné volat na tel: <b>775 442 777</b> pro pomoc!</li>
                    <li>Pořadatelé nezodpovídají za bezpečnost týmu během hry ani za jakékoli přestupky způsobené účastníky. Od účastníků se vyžaduje slušné chování, ohleduplnost vůči okolí a dodržování veškerých aktuálně platných předpisů a zákonů.</li>
                    <li>Upozorňujeme všechny účastníky, že akce bude fotografována. Vzniklé fotografie umístíme na webu a Facebooku knihovny. Pokud si nepřejete být fotografováni, prosíme, sdělte nám to. Děkujeme.</li>
                </ul>
            </Section>

            <Section>
                <p>
                    Držíme vám palce a přejeme parádní zážitek a radost z pohybu i šifrování!
                    Realizační tým ŠifTu, Městská knihovna Tábor.
                </p>
            </Section>
            
        </div>
    )
}
